var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPushNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_push_notification",
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7734",
    "data-name": "Rectangle 7734",
    width: 192,
    height: 192,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54379",
    "data-name": "Path 54379",
    d: "M96,148.363H17.454V26.181H96V55.814h17.454V0H0V192H113.454V117.328H96Zm-30.906,32.27c-13.277,8.628-27.447-5.542-18.819-18.819a7.116,7.116,0,0,1,2.085-2.084c13.277-8.628,27.446,5.541,18.818,18.819a7.125,7.125,0,0,1-2.084,2.084",
    transform: "translate(11)",
    fill: "rgba(0,0,0,0.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54380",
    "data-name": "Path 54380",
    d: "M55.447,62.814h81.01v47.845H74.34l-10.194,8.155v-8.155h-8.7Z",
    fill: "#e1251b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7729",
    "data-name": "Rectangle 7729",
    width: 28.816,
    height: 3.262,
    transform: "translate(98.943 77.494)",
    fill: "rgba(255,255,255,0.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7731",
    "data-name": "Rectangle 7731",
    width: 28.816,
    height: 3.262,
    transform: "translate(98.943 85.105)",
    fill: "rgba(255,255,255,0.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7733",
    "data-name": "Rectangle 7733",
    width: 15.362,
    height: 3.262,
    transform: "translate(98.943 92.717)",
    fill: "rgba(255,255,255,0.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54381",
    "data-name": "Path 54381",
    d: "M77.195,74.775A11.961,11.961,0,1,0,89.156,86.736,11.961,11.961,0,0,0,77.195,74.775m1.2,17.942H76V85.54h2.392Zm0-9.569H76V80.756h2.392Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushNotificationIcon);
export default __webpack_public_path__ + "static/media/push-notification-icon.acd41db68d296a9185556747435cd62b.svg";
export { ForwardRef as ReactComponent };